import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Social from "../components/social";
import { Input, message, Button } from "antd";
import { useNavigate } from "react-router-dom";
import LoginButtonTest from "./LoginButtonTest";
import { useTranslation } from "react-i18next";
import apiClient, { handleApiError } from "../utils/axiosConfig"; 
import '../styles/login.css';

const SupplierLogin = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = async () => {
    // ✅ Input validation
    if (!formData.email || !formData.password) {
      message.error(t("please_fill_all_fields") || "Please fill all fields");
      return;
    }

    // ✅ Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      message.error(t("invalid_email") || "Invalid email format");
      return;
    }

    setLoading(true);

    try {
      // ✅ apiClient kullan (axios yerine)
      const response = await apiClient.post('/api/Auth/Login', {
        email: formData.email,
        password: formData.password
      });

      // ✅ Token'ları kaydet
      const { token, refreshToken, supplierId, email, supplierName, supplierCode, role } = response.data;

      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("urlToken", token); // ✅ Tutarlılık için (kaldırılabilir)
      localStorage.setItem("user", JSON.stringify({
        supplierId,
        email,
        supplierName,
        supplierCode,
        role
      }));

      message.success(t("login_success") || "Login successful!");

      // ✅ Role'e göre yönlendir
      if (role === "SuperAdmin" || role === "Admin" || role === "Viewer") {
        navigate("/admin-dashboard");
      } else {
        navigate("/main");
      }

    } catch (error) {
      // ✅ Merkezi hata yönetimi
      const errorMessage = handleApiError(error, t("login_failed"));
      message.error(errorMessage);
      
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <div id="login">
      <Navbar />
      <div className="wrapper">
        <a href="/" className="login-logo mb-5">
          <img
            className="logo-img site-logo-img"
            src="https://daiichi.com/new_site/wp-content/uploads/2019/11/daiichi-logo-w.svg"
            width="200"
            alt="DAIICHI Electronics"
            title="Infotainment Systems"
          />
        </a>

        <form onSubmit={handleSubmit}>
          <Input
            name="email"
            type="email"
            placeholder={t("email")}
            onChange={handleChange}
            value={formData.email}
            style={{ marginBottom: "10px" }}
            disabled={loading}
          />

          <Input.Password
            name="password"
            placeholder={t("password")}
            onChange={handleChange}
            value={formData.password}
            style={{ marginBottom: "15px" }}
            disabled={loading}
          />

          {/* Azure AD Login */}
          <LoginButtonTest />

          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", marginTop: "10px" }}
            loading={loading}
          >
            {t("login")}
          </Button>

          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <a
              onClick={() => navigate("/forgot-password")}
              style={{
                cursor: "pointer",
                textDecoration: "none",
                color: "rgb(127, 205, 250)",
                fontWeight: "200",
              }}
            >
              {t("forgot_password")}
            </a>
          </div>
        </form>
      </div>
      <Social />
    </div>
  );
};

export default SupplierLogin;
